"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalHeader = void 0;
var _react = _interopRequireDefault(require("react"));
var _useInteractableHeight = require("@cbhq/cds-common/hooks/useInteractableHeight");
var _ModalParentContext = require("@cbhq/cds-common/overlays/ModalParentContext");
var _buttons = require("../../buttons");
var _layout = require("../../layout");
var _typography = require("../../typography");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const ModalHeader = ({
  title,
  onBackButtonPress,
  backAccessibilityLabel,
  backAccessibilityHint,
  closeAccessibilityLabel,
  closeAccessibilityHint
}) => {
  const height = (0, _useInteractableHeight.useInteractableHeight)(true);
  const _useModalParent = (0, _ModalParentContext.useModalParent)(),
    onRequestClose = _useModalParent.onRequestClose,
    accessibilityLabelledBy = _useModalParent.accessibilityLabelledBy,
    hideCloseButton = _useModalParent.hideCloseButton,
    hideDividers = _useModalParent.hideDividers;
  if (!title && !onBackButtonPress && !onRequestClose) return null;

  // use empty placeholder which has the same size as IconButton to maintain horizontal position
  const emptyPlaceholder = /*#__PURE__*/_react.default.createElement(_layout.Box, {
    height: height,
    width: height
  });
  return /*#__PURE__*/_react.default.createElement(_layout.HStack, {
    alignItems: "center",
    borderedBottom: !hideDividers,
    spacingHorizontal: 3,
    spacingVertical: 2
  }, /*#__PURE__*/_react.default.createElement(_layout.Box, null, onBackButtonPress ? /*#__PURE__*/_react.default.createElement(_buttons.IconButton, {
    transparent: true,
    accessibilityHint: backAccessibilityHint,
    accessibilityLabel: backAccessibilityLabel,
    name: "backArrow",
    onPress: onBackButtonPress,
    testID: "modal-back-button"
  }) : emptyPlaceholder), /*#__PURE__*/_react.default.createElement(_layout.Box, {
    alignItems: "center",
    flexGrow: 1,
    justifyContent: "center",
    spacingHorizontal: 2
  }, /*#__PURE__*/_react.default.createElement(_typography.TextHeadline, {
    align: "center",
    as: "h2",
    id: accessibilityLabelledBy
  }, title)), /*#__PURE__*/_react.default.createElement(_layout.Box, {
    justifyContent: "flex-end"
  }, !hideCloseButton ? /*#__PURE__*/_react.default.createElement(_buttons.IconButton, {
    transparent: true,
    accessibilityHint: closeAccessibilityHint,
    accessibilityLabel: closeAccessibilityLabel,
    name: "close",
    onPress: onRequestClose,
    testID: "modal-close-button"
  }) : emptyPlaceholder));
};
exports.ModalHeader = ModalHeader;